package com.mps.asc_app.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.mps.asc_app.ui.theme.AscGoldLight
import asc_app.composeapp.generated.resources.Res
import asc_app.composeapp.generated.resources.app_name
import asc_app.composeapp.generated.resources.logo_asc
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
@OptIn(ExperimentalMaterial3Api::class)
fun NavigationHead(
    isLoggedIn: Boolean,
    isAdmin: Boolean = false,
    isCompact: Boolean = false,
    onHomeClick: () -> Unit = {},
    onAdminPanelClick: () -> Unit = {},
    onLogoutClick: () -> Unit = {},
    modifier: Modifier = Modifier
) {
    TopAppBar(
        modifier = modifier.windowInsetsPadding(WindowInsets.statusBars),
        // Blaues Band wie auf der Vereinsseite.
        colors = TopAppBarDefaults.topAppBarColors(
            containerColor = MaterialTheme.colorScheme.primary,
            scrolledContainerColor = MaterialTheme.colorScheme.primary,
            titleContentColor = MaterialTheme.colorScheme.onPrimary,
            navigationIconContentColor = MaterialTheme.colorScheme.onPrimary,
            actionIconContentColor = MaterialTheme.colorScheme.onPrimary,
        ),
        navigationIcon = {
            // Logo als "Home"-Button
            IconButton(onClick = onHomeClick) {
                Image(
                    painter = painterResource(Res.drawable.logo_asc),
                    contentDescription = "Home",
                    modifier = Modifier
                        .size(36.dp)
                        .clip(CircleShape)
                        .border(2.dp, AscGoldLight, CircleShape)
                )
            }
        },
        title = {
            val titleText = stringResource(Res.string.app_name)
            Text(
                text = titleText.uppercase(),
                style = MaterialTheme.typography.titleLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        },
        // Admin und Abmelden liegen seit Redesign Stufe 2 in der Navigation unten bzw. im Profil.
        // isLoggedIn/isAdmin/onAdminPanelClick/onLogoutClick bleiben für die Plattform-Aufrufer erhalten.
    )
}